<span>{{error}}<ng-content></ng-content></span>